import {HTTP_METHODS} from '@/utils/constants/httpMethods';
import {buildQueryParams} from '@/utils/commons';

export const ACTIVITY_CONFIG = {
  ACTIVITIES: {
    endPoint: 'activities',
    method: HTTP_METHODS.POST
  },
  UPDATE_ACTIVITY: {
    endPoint: 'activities',
    method: HTTP_METHODS.PUT
  },
  SAVE_DRAFT_ACTIVITY: {
    endPoint: 'activities/draft',
    method: HTTP_METHODS.POST
  },
  UPDATE_DRAFT_ACTIVITY: {
    endPoint: 'activities/draft',
    method: HTTP_METHODS.PUT
  },
  VALIDATE_ACTIVITY_NAME: {
    endPoint: `activities/validate-name`,
    method: HTTP_METHODS.GET,
    appendQueryParams: true
  },
  GET_ACTIVITY: {
    endPoint: 'activities/list',
    method: HTTP_METHODS.POST,
    appendQueryParams: true
    // mockData: ActivitiesData
  },
  ACTIVITY_CSV_DOWNLOAD: (queryParams) => {
    const query = queryParams ? `?${buildQueryParams(queryParams)}` : '';
    return {
      endPoint: `activities/download${query}`,
      method: HTTP_METHODS.POST
    };
  },
  ACTIVITY_REPORT_DOWNLOAD: (activityId) => ({
    endPoint: `activities/download-report?activityId=${encodeURIComponent(activityId)}`,
    method: HTTP_METHODS.GET
  }),
  GAME_PARTICIPATION_REPORT_DOWNLOAD: (gameId) => ({
    endPoint: `activities/game-participation-report?gameId=${encodeURIComponent(gameId)}`,
    method: HTTP_METHODS.GET
  }),

  ACTIVITY_DURATION_VALIDATION: {
    endPoint: 'activities/validate',
    method: HTTP_METHODS.POST
  },
  ACTIVITY_HISTORY: {
    endPoint: 'rewards/users/activities',
    method: HTTP_METHODS.GET
  },
  SEARCH_PHONE_NUMBER: {
    endPoint: 'rewards/users/stores',
    method: HTTP_METHODS.GET
  },
  PATCH_ACTIVITY_STATUS: (id) => ({
    endPoint: `activities/${encodeURIComponent(id)}`,
    method: HTTP_METHODS.PATCH
  })
};
